import { z } from 'zod';

// Mirrors backend RegisterDto constraints exactly
export const registerSchema = z
  .object({
    firstName: z.string().trim().min(1, 'Le prénom est requis').max(50, 'Le prénom ne peut pas dépasser 50 caractères'),
    lastName: z.string().trim().min(1, 'Le nom est requis').max(50, 'Le nom ne peut pas dépasser 50 caractères'),
    username: z
      .string()
      .trim()
      .min(3, "Le nom d'utilisateur doit comporter au moins 3 caractères")
      .max(30, "Le nom d'utilisateur ne peut pas dépasser 30 caractères")
      .regex(
        /^[a-z0-9._-]+$/,
        "Le nom d'utilisateur ne peut contenir que des lettres minuscules, chiffres, points, tirets et underscores",
      ),
    email: z.string().trim().min(1, "L'email est requis").email('Adresse email invalide').max(255, 'Email trop long'),
    password: z
      .string()
      .min(8, 'Le mot de passe doit comporter au moins 8 caractères')
      .regex(/[A-Z]/, 'Le mot de passe doit contenir au moins une majuscule')
      .regex(/\d/, 'Le mot de passe doit contenir au moins un chiffre'),
    confirmPassword: z.string().min(1, 'La confirmation est requise'),
    referralCode: z.string().trim().max(20, 'Code parrainage trop long').optional().or(z.literal('')),
    acceptCgu: z.literal(true, {
      error: 'Vous devez accepter les CGU',
    }),
  })
  .refine(d => d.password === d.confirmPassword, {
    message: 'Les mots de passe ne correspondent pas',
    path: ['confirmPassword'],
  });

export type RegisterFormData = z.infer<typeof registerSchema>;
